import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { combineReducers, createStore } from 'redux';
import { apartments } from './reducers/apartments';
import { handymen } from './reducers/handymen';
import { heating } from './reducers/heating';
import { login } from './reducers/login';
import { mover } from './reducers/mover';
import { news } from './reducers/news';
import { rate } from './reducers/rate';
import { waitingList } from './reducers/waitingList';
import { Provider } from 'react-redux'
import {
    BrowserRouter as Router
} from "react-router-dom";

const housingApp = combineReducers({
    apartments,
    handymen,
    heating,
    login,
    mover,
    news,
    rate,
    waitingList
})

export const store = createStore(housingApp);

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <Provider store={store}>
        <Router>
            <App />
        </Router>
    </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
